import React, { useEffect, useState } from "react";
import Dialog from "@material-ui/core/Dialog";
import { useTheme } from '@material-ui/core/styles';
import { useDispatch, useSelector } from "react-redux";
import { useSetState } from "Helpers/Hooks";
import DialogContent from "@material-ui/core/DialogContent";
import Grid from "@material-ui/core/Grid";
import Translator from "Languages/Utility/Translator";
import { getAllBrandYaragh, getAllYaragh, getAllYaraghCountry, InsertAutoBrandYaragh } from "Stores/actions";
import { read } from "Helpers/LocalStorage";
import showNotify from "Helpers/Notify";
import MuiButton from "Components/MuiButton/MuiButton";
import MuiToggleButtonGroup from "Components/MuiToggleButtonGroup/MuiToggleButtonGroup";
import { toggleNAluminiumUpvc } from "Constants/Constants";
import BrandTable from "./components/BrandTable";
import Input from "Components/Input/Input";
import { CircularProgress, DialogActions } from "@material-ui/core";
import { useTranslation } from 'react-i18next';
import MuiRadioGroup from "Components/MuiRadioGroup/MuiRadioGroup";

function ArchiveDialog() {
  const { direction } = useTheme();
  const { t } = useTranslation();
  const { arshivBrandData, arshivBrandDataPagination } = useSelector(
    (state) => ({
      arshivBrandData: state.yaragh.arshivBrandData,
      arshivBrandDataPagination: state.yaragh.arshivBrandDataPagination,
    })
  );
  const dispatch = useDispatch();
  const [tblData, setTblData] = useState(arshivBrandData);
  const [selectedRow, setSelectedRow] = useState({});
  const [loading, setLoading] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [controls, setControls] = useSetState({
    keshvar: {
      type: "toggle",
      arrayItems: [],
      value: "1",
      validation: {
        required: true,
      },
      col: {
        sm: 12,
        xs: 12
      },
    },
    struct: {
      type: "toggle",
      arrayItems: toggleNAluminiumUpvc,
      value: toggleNAluminiumUpvc[0],
      validation: {
        required: true,
      },
      col: {
        sm: 12,
        xs: 12
      },
    },
    nameSearch: {
      type: "search",
      value: null,
      validation: null,
      col: {
        sm: 12,
        xs: 12
      },
    },
  });

  const onSelectRow = (row) => {
    setSelectedRow(row);
  };

  const onChangeToggle = async (name, key, value) => {
    setControls({ [name]: { value: value } });
    setLoading(true);
    if (name === "keshvar") {
      try {
        const params = {
          KeyUser: read("userKey"),
          KeyGroup: read("groupKey"),
          limit: 10,
          page: 1,
          IdStruct: controls.struct.value.value === "upvc" ? 1 : 2,
          IdCountry: value.value,
          Name: controls.nameSearch.value,
        };
        await dispatch(getAllBrandYaragh(params));
      } catch (err) {
      console.error('[catch error]', err)
    }
    }
    if (name === "struct") {
      try {
        const params = {
          KeyUser: read("userKey"),
          KeyGroup: read("groupKey"),
          Limit: 10,
          Page: 1,
          IdStruct: value.value === "upvc" ? 1 : 2,
          IdCountry: controls.keshvar.value.value,
          Name: controls.nameSearch.value,
        };
        await dispatch(getAllBrandYaragh(params));
      } catch (err) {
      console.error('[catch error]', err)
    }
    }
    setLoading(false);
  };

  const handleDialog = () => {
    setOpenDialog(!openDialog);
  };

  const onFinish = async (e) => {
    e.preventDefault();
    if (selectedRow.Key) {
      try {
        const data = {
          KeyGroup: read("groupKey"),
          KeyUser: read("userKey"),
          KeyBrand: selectedRow.Key,
        };
        await dispatch(InsertAutoBrandYaragh(data));
        handleDialog();
        const params = { KeyGroup: read("groupKey"), KeyUser: read("userKey") };
        await dispatch(getAllYaragh(params));
      } catch (e) {
        showNotify({
          text: t('correctFormDataRequired'),
          customClass: "error",
        });
      }
    } else {
      showNotify({
        text: t('selectYaraghBrand'),
        customClass: "error",
      });
    }
  };

  const onEnter = async () => {
    setControls({ nameSearch: { value: null } });
    setControls({ struct: { value: toggleNAluminiumUpvc[0] } });
    try {
      setLoading(true);
      const params = {
        KeyUser: read("userKey"),
        KeyGroup: read("groupKey"),
      };
      let res = await dispatch(getAllYaraghCountry(params));
      res = res.map(i => {
        return {
          ...i, 
          key : i.Name.trim()
        }
      })
      setControls({ keshvar: { arrayItems: res } });
      setControls({ keshvar: { value: res[0] } });
      const paramsBrand = {
        KeyUser: read("userKey"),
        KeyGroup: read("groupKey"),
        Limit: arshivBrandDataPagination.Limit,
        Page: arshivBrandDataPagination.Page,
        IdStruct: 1,
        IdCountry: res[0].value,
        Name: "",
      };
      await dispatch(getAllBrandYaragh(paramsBrand));
      setLoading(false);
    } catch (err) {
      console.error('[catch error]', err)
    }
  };

  const setValue = (name, value) => setControls({ [name]: { value: value } });

  const onSearch = async (e) => {
    e.preventDefault();
    getDataOnSearch(controls.nameSearch.value);
  }

  const onClearSearch = async (e) => {
    e.preventDefault();
    setControls({ nameSearch: { value: '' } })
    getDataOnSearch('');
  }

  useEffect(() => {
    setTblData(arshivBrandData.map(i => { return {...i, Id: i.num} }));
  }, [arshivBrandData]);

  const getDataOnSearch = (value) => {
    setLoading(true);
    try {
      const paramsBrand = {
        KeyUser: read("userKey"),
        KeyGroup: read("groupKey"),
        Limit: arshivBrandDataPagination.Limit,
        Page: arshivBrandDataPagination.Page,
        IdStruct: controls.struct.value.value === "upvc" ? 1 : 2,
        IdCountry: controls.keshvar.value.value,
        Name: value,
      };
      dispatch(getAllBrandYaragh(paramsBrand));
      setLoading(false);
    } catch (err) {
      console.error('[catch error]', err)
    }
  }
  useEffect(() => {
    if (controls.nameSearch.value !== null) {
      getDataOnSearch(controls.nameSearch.value)
    }
  }, [controls.nameSearch]);

  return (
    <>
      <MuiButton
        loading={loading}
        color="secondary"
        title={<Translator id={"archiveFittingBrand"} />}
        onClick={handleDialog}
      />
      <Dialog
        dir={direction}
        open={openDialog}
        onClose={handleDialog}
        onEnter={onEnter}
        fullWidth
        maxWidth="sm"
      >
        <form onSubmit={onFinish}>
          <div className="dialogHeader">
            <p> {<Translator id={"archiveFittingBrand"} />}</p>
          </div>
          <DialogContent id="content-dialog-manager">
              <Grid container spacing={2}>
                {!loading && Object.keys(controls).map((key, index) => {
                  return (
                    <Grid item md={controls[key].col.md} sm={controls[key].col.sm} xs={controls[key].col.xs} key={key + index} className="d-flex justify-content-end">
                      {
                        controls[key].type === "search" &&
                        <Input
                          setValue={setValue.bind(this)}
                          name={key}
                          value={controls[key].value ? controls[key].value : ""}
                          placeholder={t(key)}
                          type="search"
                          onSearch={onSearch}
                          onClearSearch={onClearSearch}
                        />
                      }
                      {
                        controls[key].type === "toggle" &&
                        <MuiRadioGroup
                            name={key}
                            label={<Translator id={key} />}
                            value={controls[key].value}
                            items={controls[key].arrayItems}
                            onChange={onChangeToggle}
                            translate={true}
                            className="horizontalRadio"
                          />
                      }
                    </Grid>
                  );
                })}
                <Grid item xs={12}>
                  {
                    !loading
                    ? <Grid item xs={12}>
                        <BrandTable
                          data={tblData}
                          onSelect={onSelectRow}
                          selected={selectedRow}
                          idCountry={controls.keshvar.value.value}
                          idStruct={controls.struct.value.value === "upvc" ? 1 : 2}
                        />
                    </Grid>
                    : <div className="text-center text-muted">
                        <CircularProgress style={{'color' : 'Gray'}}/>
                        <p>{t('pleaseWait')}</p>
                    </div>
                  }
                </Grid>
              </Grid>
          </DialogContent>
          <DialogActions>
            <MuiButton
              color="primary"
              type="submit"
              title={<Translator id="button_save" />}
              disabled={loading}
            />
            <MuiButton
              onClick={handleDialog}
              title={<Translator id="enseraf" />}
              disabled={loading}
            />
          </DialogActions>
        </form>
      </Dialog>
    </>
  );
}

export default ArchiveDialog;
